module.exports = __webpack_public_path__ + "b452b0191704cbccf74f4538c0b04de6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/sectors_bg@2x.jpg
// module id = 665
// module chunks = 0